import {Typography} from 'components/Typography';
import {FC} from 'react';
import style from './style.module.scss';
import {useInView} from 'react-intersection-observer';
import {EventAction, EventNames} from 'modules/google-analytics/constants';
import {sendGtagEvent} from 'hooks/analytics/gtag/helpers';

interface IProps {
    titleVinoteki: string;
}

const WineryWarning: FC<IProps> = ({titleVinoteki}) => {
    const {ref} = useInView({
        triggerOnce: true,
        onChange: (inView) => {
            if (inView) {
                sendGtagEvent({
                    eventCategory: 'nonInteractions_checkout_today',
                    event: EventNames.OWOX,
                    eventAction: EventAction.Error,
                    eventLabel: 'Этого товара сегодня нет в наличии',
                });
            }
        },
    });

    if (!titleVinoteki) {
        return null;
    }

    return (
        <div ref={ref} className={style.wineryWarning}>
            <div className={style.wineryWarningContent}>
                <Typography variant={'label-14-r'}>Этого товара сегодня нет в {titleVinoteki}</Typography>
            </div>
        </div>
    );
};

export default WineryWarning;
